export enum HttpStatus {
  FORBIDDEN_403 = 403,
  NOT_FOUND_404 = 404,
}
